export default __webpack_public_path__ + "static/media/gallery-12.0a3efbee.jpg";